import React, { Component, Fragment } from "react";
import classNames from "classnames";
import moment from "moment";
import OrderDetails from "./orderDetails.jsx";
import { currencyFormatter } from "../../utils/display";
import TrackingInfo from "../common//trackingInfo.jsx";
import StatusMessage from "../common/statusMessage.jsx";
import { Receipt } from "../../modules/Order";
import ReactModal from "react-modal";

class ReceiptModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <ReactModal
        onRequestClose={() => {
          this.props.onClose();
        }}
        isOpen={this.props.orderUUID != null}
      >
        {this.props.orderUUID && <Receipt orderId={this.props.orderUUID} />}
      </ReactModal>
    );
  }
}

export default class OrderPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderUUID: null,
    };
  }

  render() {
    const {
      chooseActivePanel,
      activePanel,
      orderType,
      id,
      orderId,
      value,
      date,
      status,
      currentPage,
      order,
      cards,
      openSupportModal,
      openSupportCardLevelModal,
      orderSupportInfoCommon,
      openCancelSellOrderModal,
      toggleHelpOptions,
      canCancel,
      showLocalSpinner,
      userActions,
      toggleCardHelpButtons,
      renderCardHelpButtons,
      closeCardHelpButtons,
      openPaymentDetailsModal,
    } = this.props;

    const panelIconClasses = classNames("hide-sm", {
      "fa fa-angle-up fa-lg": activePanel === id,
      "fa fa-angle-down fa-lg": activePanel !== id,
    });

    const panelClasses = classNames(
      "flex-column",
      "panel-border",
      "add-margin-sm-screen",
      {
        "active-panel-material": activePanel === id,
        "mar-t-20": activePanel === id,
        "mar-b-20": activePanel === id,
      }
    );

    const responsivePanelClasses = classNames(
      "responsive-panel-table",
      "responsive-mobile",
      "fixed-table",
      "pointer",
      {
        "remove-border-btm-mobile": activePanel === id,
        "remove-panel-btm-border": activePanel === id,
      }
    );

    const ShowSpinner = () => {
      if (showLocalSpinner && activePanel === id) {
        return <div id="localLoader" />;
      }
      return null;
    };

    let trackingUrl =
      order.shippingDetails && order.shippingDetails.trackingUrl;

    return (
      <div className={panelClasses}>
        <table
          className={responsivePanelClasses}
          onClick={chooseActivePanel.bind(null, id)}
        >
          <tbody>
            <tr>
              <td className="panel-column">
                <div className="responsive-panel flex-column">
                  <span className="acct-txt-12 hide-lg">
                    <span>{orderType} </span>
                  </span>
                  <span className="acct-blue-label pad-r-5 ft-bold">
                    #{orderId}
                  </span>
                </div>
              </td>
              <td className="panel-column">
                <div className="responsive-panel flex-column">
                  <span className="acct-txt-12 hide-lg">
                    <span>Order Placed: </span>
                  </span>
                  <span className="acct-txt-12 ft-bold">
                    <span>{moment(date).format("MMM D, YYYY")}</span>
                  </span>
                </div>
              </td>
              <td className="panel-column">
                <div className="responsive-panel flex-column">
                  <span className="acct-txt-12 hide-lg">
                    <span>Status: </span>
                  </span>
                  <span className="acct-txt-12 ft-bold">
                    {status}
                    {trackingUrl ? (
                      <a
                        href={trackingUrl}
                        target="_blank"
                        className="track-shipping-btn"
                      >
                        Track
                      </a>
                    ) : null}
                  </span>
                </div>
              </td>
              <td className="panel-column">
                <div className="responsive-panel flex-column">
                  <span className="acct-txt-12 hide-lg">
                    <span>Entered Amount: </span>
                  </span>
                  <span className="acct-txt-12 ft-bold">
                    {currencyFormatter(value)}
                  </span>
                </div>
              </td>
              {canCancel ? (
                <td className="panel-column panel-column-sm">
                  <span
                    className="acct-pg-edit-link acct-txt-12"
                    onClick={(e) => {
                      openCancelSellOrderModal(e, id);
                    }}
                  >
                    Cancel
                  </span>
                </td>
              ) : (
                <td className="cancel-placeholder panel-column panel-column-sm" />
              )}
              <td className="panel-column panel-column-sm">
                <i className={panelIconClasses} />
              </td>
            </tr>
          </tbody>
        </table>
        <div
          onClick={chooseActivePanel.bind(null, id)}
          className="panel-details-heading hide-lg"
        >
          <div>Order Details</div>
          <i
            className={
              activePanel === id
                ? "fa fa-angle-up fa-lg ft-bold"
                : "fa fa-angle-down fa-lg ft-bold"
            }
          />
        </div>
        {activePanel === id && Object.keys(order).length && cards.length ? (
          [
            <div key={id}>
              {order.status_message && (
                <StatusMessage statusMessage={order.status_message} />
              )}
              {trackingUrl && <TrackingInfo trackingUrl={trackingUrl} />}
            </div>,
            <OrderDetails
              currentPage={currentPage}
              order={order}
              cards={cards}
              activePanel={activePanel}
              id={id}
              openSupportModal={openSupportModal}
              orderSupportInfoCommon={orderSupportInfoCommon}
              openSupportCardLevelModal={openSupportCardLevelModal}
              toggleHelpOptions={toggleHelpOptions}
              userActions={userActions}
              toggleCardHelpButtons={toggleCardHelpButtons}
              renderCardHelpButtons={renderCardHelpButtons}
              closeCardHelpButtons={closeCardHelpButtons}
              showLocalSpinner={showLocalSpinner}
              openPaymentDetailsModal={openPaymentDetailsModal}
            />,
            <div style={{ position: "relative" }}>
              <button
                style={{
                  bottom: 0,
                  right: 0,
                  position: "absolute",
                  border: "none",
                  background: "none",
                }}
                onClick={() => this.setState({ orderUUID: id })}
                className="acct-pg-edit-link"
              >
                Show Receipt
              </button>
            </div>,
          ]
        ) : (
          <ShowSpinner />
        )}
        <ReceiptModal
          orderUUID={this.state.orderUUID}
          onClose={() => {
            this.setState({ orderUUID: null });
          }}
        />
      </div>
    );
  }
}
